import * as m from "#/paraglide/messages";
import {
  createBackendFailureMessageResolver,
  readBackendFailure,
} from "#/shared/lib/backend-api";

import {
  getConversationMessagesOperation,
  type GetConversationMessagesOperation,
} from "../api/get-conversation-messages";
import {
  getConversationsOperation,
  type GetConversationsOperation,
} from "../api/get-conversations";

type ConversationsOperation =
  GetConversationMessagesOperation | GetConversationsOperation;

const resolveFailureMessage =
  createBackendFailureMessageResolver<ConversationsOperation>({
    forbidden: () => m.inbox_conversations_failure_forbidden(),
    network: () => m.inbox_conversations_failure_network(),
    rejected: () => m.inbox_conversations_failure_rejected(),
    schema: () => m.inbox_conversations_failure_schema(),
    unexpected: () => m.inbox_conversations_failure_unexpected(),
  });

/**
 * 把读列表或读回放时抛出的任意错误翻成一句可展示文案。
 * 两个读操作共用一组文案：商家要知道的是"会话取不到"，不是取的是哪一段。
 */
export function readConversationsFailureMessage(error: unknown): string | null {
  return resolveFailureMessage(
    readBackendFailure(error, [
      getConversationsOperation,
      getConversationMessagesOperation,
    ]),
  );
}
